// extracted by mini-css-extract-plugin
export var attachButton = "_k6-8";
export var sendButton = "_k6-2";
export var sendDisabled = "_k6-4";
export var sendEnabled = "_k6-3";
export var sendIcon = "_k6-6";
export var sendIconDisabled = "_k6-7";
export var sendStreaming = "_k6-5";
export var textarea = "_k6-1";
export var wrapper = "_k6-0";